import React, { Component } from "react";
import _ from "lodash";

class BasicButton extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let classnames;
    if (_.isArray(this.props.className)) {
      classnames = this.props.className.join(" ");
    } else {
      classnames = this.props.className;
    }

    let styles = this.props.style ? this.props.style : defaultStyle;

    return (
      <button
        className={"btn card-button " + classnames}
        style={styles}
        disabled={this.props.disabled}
        onChange={this.props.on_change}
        onClick={this.props.on_click}
        aria-label={this.props.aria_label}
      >
        {this.props.label}
      </button>
    );
  }
}

const defaultStyle = {
  width: "100%",
  // padding: '5px',
  margin: "9px 2px",
};

export default BasicButton;
